// Block-stance countdown — a thin blue bar that sits just ABOVE the stamina bar while a block is
// raised, draining over the block's duration. Hidden when not blocking. Driven each frame from
// world3d via setBlockProgress (1 = just raised, 0 = elapsed/broken → hidden).

import { injectTheme } from "./theme.js";
import { registerBottomSlot, setBottomSlot } from "./bottomStack.js";

const STYLE_ID = "ghostland-block-style";
const CSS = `
#gl-block {
  position: fixed; left: 50%; bottom: 120px; transform: translateX(-50%); z-index: 26;
  width: 220px; opacity: 0; transition: opacity .12s ease; pointer-events: none;
  font-family: ui-monospace, "SFMono-Regular", Menlo, monospace; user-select: none;
}
#gl-block.show { opacity: 1; }
#gl-block .lbl { font-size: 9px; letter-spacing: .14em; color: #8fd2ff; text-align: center; margin-bottom: 2px; }
#gl-block .bar {
  position: relative; height: 7px; border-radius: 4px; overflow: hidden;
  background: var(--gl-panel-2); box-shadow: inset 0 0 0 1px var(--gl-border);
}
#gl-block .fill { position: absolute; inset: 0; right: 0; transition: width .05s linear;
  background: linear-gradient(#8fd6ff, #2f8fe0); }
`;

let root: HTMLDivElement | null = null;
let fill: HTMLDivElement | null = null;

/** Mount the block countdown bar (idempotent). */
export function mountBlockHud(): void {
  if (root) return;
  injectTheme();
  if (!document.getElementById(STYLE_ID)) {
    const s = document.createElement("style"); s.id = STYLE_ID; s.textContent = CSS; document.head.appendChild(s);
  }
  root = document.createElement("div");
  root.id = "gl-block";
  root.innerHTML = `<div class="lbl">BLOCK</div><div class="bar"><div class="fill"></div></div>`;
  document.body.appendChild(root);
  registerBottomSlot("block", root); // stacks above the stamina bar when both show
  fill = root.querySelector(".fill");
}

/** Drive the bar: `frac` 1→0 over the block stance; ≤0 hides it. */
export function setBlockProgress(frac: number): void {
  if (!root) return;
  const f = Math.max(0, Math.min(1, frac));
  const show = f > 0.001;
  root.classList.toggle("show", show);
  if (fill) fill.style.width = `${(f * 100).toFixed(1)}%`;
  setBottomSlot("block", show);
}
